import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "../../redux/language/selector";

const PdfViewer6 = () => {
  const { t } = useTranslation();

  const language = useSelector(selectLanguage);

  useEffect(() => {
    document.title = t("pdf.dieukhoan");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);
  return (
    <div style={{ height: "100vh", width: "100%" }}>
      <iframe
        src="/uploads/GoPaperless_Điều kiện và Điều khoản sử dụng.pdf"
        width="100%"
        height="100%"
        style={{ border: "none" }}
        title="dieukhoan"
      ></iframe>
    </div>
  );
};

export default PdfViewer6;
